const NFC_DATE_CORRECTION = {
  Initial: 'Initial',
  SCAN: 'SCAN',
  OK: 'NFC_DATE_OK',
  FAILED: 'NFC_DATE_FAILED'
};

const progressbarTypes = {
  finished: 'finished',
  loading: 'loading'
};

const SCAN_COMMAND = {
  // **** static native command **** //
  // started
  STARTED: 'NFC_STARTED',
  // communicate
  COMMUNICATING: 'NFC_COMMUNICATING',
  // reading
  READING: 'NFC_READING',
  READING_STARTED: 'NFC_READING_STARTED',
  // finish
  FINISHED_OK: 'NFC_FINISHED_OK',
  FINISHED_FAILED: 'NFC_FINISHED_FAILED',
  // date
  DATE_TYPE1: 'NFC_DATE_TYPE1',
  // length
  DATA_LENGTH: 'NFC_DATA_LENGTH',
  // unable to read
  UNABLE_TO_READ: 'UNABLE_TO_READ',
  // **** defined in react commands **** //
  RESPONSE_SERVER_WAITING: 'RESPONSE_SERVER_WAITING',
  RESPONSE_SERVER_OK: 'RESPONSE_SERVER_OK',
  RESPONSE_SERVER_FAILED: 'RESPONSE_SERVER_FAILED',
  RESPONSE_REGISTER_PATIENT: 'RESPONSE_REGISTER_PATIENT'
};

const NFC_SUPPORT_TYPE = {
  not_support: 'not_support',
  disabled: 'disabled'
};

const scanButtonTypes = {
  default: 'default',
  retry: 'retry',
  success: 'success',
  disabled: 'disabled',
  blockClick: 'blockClick',
  finishedOk: 'finishedOk'
};

export {
  scanButtonTypes,
  progressbarTypes,
  SCAN_COMMAND,
  NFC_DATE_CORRECTION,
  NFC_SUPPORT_TYPE
};
